export var version = "30.0.0-rc.28";
export var baseUrl = "https://cdn.finnair.com/fcom-ui-styles/prod/";
export var iconLibrary = {
    "custom": {
        "Deutsche_Bahn": "icons/custom/Deutsche_Bahn.d2133.svg",
        "allianz-logo": "icons/custom/allianz-logo.7b92f.svg",
        "apple-wallet-en": "icons/custom/apple-wallet-en.a7916.svg",
        "apple-wallet-fi": "icons/custom/apple-wallet-fi.dc98f.svg",
        "avios-keyline-navy": "icons/custom/avios-keyline-navy.3ffdd.svg",
        "avios-keyline-white": "icons/custom/avios-keyline-white.2cf70.svg",
        "avios-small-use-navy": "icons/custom/avios-small-use-navy.a209f.svg",
        "avios-small-use-white": "icons/custom/avios-small-use-white.c0ba7.svg",
        "ba-club": "icons/custom/ba-club.cd01d.svg",
        "baec-emblem": "icons/custom/baec-emblem.1bd35.svg",
        "baec-logo": "icons/custom/baec-logo.f5da0.svg",
        "business-bassinet-seat": "icons/custom/business-bassinet-seat.9846b.svg",
        "cartrawler-logo": "icons/custom/cartrawler-logo.c78a9.svg",
        "comfort-seat": "icons/custom/comfort-seat.180bd.svg",
        "economy-bassinet-seat": "icons/custom/economy-bassinet-seat.9846b.svg",
        "exit-row-seat": "icons/custom/exit-row-seat.8b03b.svg",
        "extra-legroom-seat": "icons/custom/extra-legroom-seat.30c41.svg",
        "finnair-emblem": "icons/custom/finnair-emblem.7e5f3.svg",
        "finnair-logo-100": "icons/custom/finnair-logo-100.d4d97.svg",
        "finnair-logo-plus": "icons/custom/finnair-logo-plus.5ccaa.svg",
        "finnair-logo": "icons/custom/finnair-logo.f8e3e.svg",
        "front-row-seat": "icons/custom/front-row-seat.fc12b.svg",
        "google-wallet-en": "icons/custom/google-wallet-en.e67f5.svg",
        "google-wallet-fi": "icons/custom/google-wallet-fi.b7362.svg",
        "hotels-logo": "icons/custom/hotels-logo.ae27e.svg",
        "plus-card-basic-bg": "icons/custom/plus-card-basic-bg.b9b10.svg",
        "plus-card-basic": "icons/custom/plus-card-basic.2dec6.svg",
        "plus-card-gold-bg": "icons/custom/plus-card-gold-bg.412b7.svg",
        "plus-card-gold": "icons/custom/plus-card-gold.e84b8.svg",
        "plus-card-junior-bg": "icons/custom/plus-card-junior-bg.fc53b.svg",
        "plus-card-junior": "icons/custom/plus-card-junior.9a0fe.svg",
        "plus-card-lumo-bg": "icons/custom/plus-card-lumo-bg.fa394.svg",
        "plus-card-lumo": "icons/custom/plus-card-lumo.57d9c.svg",
        "plus-card-platinum-bg": "icons/custom/plus-card-platinum-bg.9a14d.svg",
        "plus-card-platinum": "icons/custom/plus-card-platinum.1011b.svg",
        "plus-card-silver-bg": "icons/custom/plus-card-silver-bg.c19a4.svg",
        "plus-card-silver": "icons/custom/plus-card-silver.f91ed.svg",
        "plus-icon-basic": "icons/custom/plus-icon-basic.ff694.svg",
        "plus-icon-gold": "icons/custom/plus-icon-gold.d8ea3.svg",
        "plus-icon-lumo": "icons/custom/plus-icon-lumo.636b5.svg",
        "plus-icon-platinum": "icons/custom/plus-icon-platinum.cb14e.svg",
        "plus-icon-silver": "icons/custom/plus-icon-silver.11cd5.svg",
        "preferred-seat": "icons/custom/preferred-seat.2f5b4.svg",
        "premium-bassinet-seat": "icons/custom/premium-bassinet-seat.1fcd5.svg",
        "premium-seat": "icons/custom/premium-seat.01f29.svg",
        "regular-seat": "icons/custom/regular-seat.78361.svg",
        "selected-seat": "icons/custom/selected-seat.846f5.svg",
        "unavailable-seat": "icons/custom/unavailable-seat.096cb.svg"
    },
    "payments": {
        "adyenpaymentcard": "icons/payments/adyenpaymentcard.d9e78.svg",
        "aktia": "icons/payments/aktia.33b18.svg",
        "alandsbanken": "icons/payments/alandsbanken.3378d.svg",
        "alipay": "icons/payments/alipay.b293f.svg",
        "amex": "icons/payments/amex.48faa.svg",
        "applepay": "icons/payments/applepay.c73a9.svg",
        "arbejdernes": "icons/payments/arbejdernes.921f4.svg",
        "barclays": "icons/payments/barclays.0295f.svg",
        "citadele": "icons/payments/citadele.751cc.svg",
        "cooppank": "icons/payments/cooppank.35962.svg",
        "danskebank": "icons/payments/danskebank.79118.svg",
        "dinersclub": "icons/payments/dinersclub.0f38b.svg",
        "discover": "icons/payments/discover.9136a.svg",
        "dnb": "icons/payments/dnb.2cda1.svg",
        "giropay": "icons/payments/giropay.87fc4.svg",
        "handelsbanken": "icons/payments/handelsbanken.aa726.svg",
        "hsbcuk": "icons/payments/hsbcuk.07776.svg",
        "ideal": "icons/payments/ideal.77d9a.svg",
        "indianetbanking": "icons/payments/indianetbanking.fc790.svg",
        "indiawallet": "icons/payments/indiawallet.1549b.svg",
        "jcb": "icons/payments/jcb.13e0d.svg",
        "jyskebank": "icons/payments/jyskebank.5b0fe.svg",
        "klarna": "icons/payments/klarna.49b4f.svg",
        "lansforsakringar": "icons/payments/lansforsakringar.de660.svg",
        "lhvpank": "icons/payments/lhvpank.37e67.svg",
        "lloydsbank": "icons/payments/lloydsbank.6b387.svg",
        "luminor": "icons/payments/luminor.5221e.svg",
        "lunarbank": "icons/payments/lunarbank.47a23.svg",
        "mastercard": "icons/payments/mastercard.d9582.svg",
        "mobilepay": "icons/payments/mobilepay.f2b9f.svg",
        "natwest": "icons/payments/natwest.2d8cd.svg",
        "nordea": "icons/payments/nordea.6fd27.svg",
        "nykreditbank": "icons/payments/nykreditbank.0d286.svg",
        "omasp": "icons/payments/omasp.8a216.svg",
        "op": "icons/payments/op.acd4d.svg",
        "paypal": "icons/payments/paypal.65909.svg",
        "poppankki": "icons/payments/poppankki.bb4cc.svg",
        "revolut": "icons/payments/revolut.abf4f.svg",
        "rupay": "icons/payments/rupay.77a27.svg",
        "saastopankki": "icons/payments/saastopankki.8299c.svg",
        "santanderuk": "icons/payments/santanderuk.68004.svg",
        "sbanken": "icons/payments/sbanken.3737c.svg",
        "seb": "icons/payments/seb.562f6.svg",
        "sofort": "icons/payments/sofort.bab59.svg",
        "spankki": "icons/payments/spankki.4e4b1.svg",
        "sparebank1no": "icons/payments/sparebank1no.11b06.svg",
        "sparebank1sm": "icons/payments/sparebank1sm.8de66.svg",
        "sparebankost": "icons/payments/sparebankost.b2477.svg",
        "swedbank": "icons/payments/swedbank.f3cad.svg",
        "swish": "icons/payments/swish.74e27.svg",
        "trustly": "icons/payments/trustly.da22a.svg",
        "uatp": "icons/payments/uatp.5d789.svg",
        "unionpay": "icons/payments/unionpay.a9761.svg",
        "upi": "icons/payments/upi.9a483.svg",
        "vipps": "icons/payments/vipps.96768.svg",
        "visa": "icons/payments/visa.12919.svg",
        "wechatpay": "icons/payments/wechatpay.c65ca.svg"
    },
    "svg-library": {
        "adult-infant-block": "icons/svg-library/adult-infant-block.cae3a.svg",
        "adult-infant-outline": "icons/svg-library/adult-infant-outline.01326.svg",
        "adult-infant": "icons/svg-library/adult-infant.fa382.svg",
        "aircraft-horizontal-block": "icons/svg-library/aircraft-horizontal-block.874df.svg",
        "aircraft-horizontal-outline": "icons/svg-library/aircraft-horizontal-outline.936c7.svg",
        "aircraft-horizontal": "icons/svg-library/aircraft-horizontal.ab59c.svg",
        "aircraft-tilted-block": "icons/svg-library/aircraft-tilted-block.8735f.svg",
        "aircraft-tilted-outline": "icons/svg-library/aircraft-tilted-outline.5bc02.svg",
        "aircraft-tilted": "icons/svg-library/aircraft-tilted.e0a92.svg",
        "aircraft-vertical-block": "icons/svg-library/aircraft-vertical-block.b552c.svg",
        "aircraft-vertical-outline": "icons/svg-library/aircraft-vertical-outline.d812f.svg",
        "aircraft-vertical": "icons/svg-library/aircraft-vertical.b4073.svg",
        "airport-block": "icons/svg-library/airport-block.13f23.svg",
        "airport-outline": "icons/svg-library/airport-outline.95368.svg",
        "airport": "icons/svg-library/airport.ceafa.svg",
        "alert-block": "icons/svg-library/alert-block.fdf4e.svg",
        "alert-outline": "icons/svg-library/alert-outline.d47dc.svg",
        "alert-triangle": "icons/svg-library/alert-triangle.07703.svg",
        "alert": "icons/svg-library/alert.dead5.svg",
        "am-logo": "icons/svg-library/am-logo.cfc32.svg",
        "area-map-block": "icons/svg-library/area-map-block.d2c19.svg",
        "area-map-outline": "icons/svg-library/area-map-outline.c837a.svg",
        "area-map": "icons/svg-library/area-map.02b82.svg",
        "arrival-block": "icons/svg-library/arrival-block.8e340.svg",
        "arrival-outline": "icons/svg-library/arrival-outline.a339e.svg",
        "arrival": "icons/svg-library/arrival.0c52d.svg",
        "arrow-back-block": "icons/svg-library/arrow-back-block.1960e.svg",
        "arrow-back-outline": "icons/svg-library/arrow-back-outline.51f5b.svg",
        "arrow-back": "icons/svg-library/arrow-back.507fd.svg",
        "arrow-down-block": "icons/svg-library/arrow-down-block.7b710.svg",
        "arrow-down-outline": "icons/svg-library/arrow-down-outline.56f99.svg",
        "arrow-down": "icons/svg-library/arrow-down.5f223.svg",
        "arrow-left-block": "icons/svg-library/arrow-left-block.b6331.svg",
        "arrow-left-outline": "icons/svg-library/arrow-left-outline.8118f.svg",
        "arrow-left": "icons/svg-library/arrow-left.b376c.svg",
        "arrow-right-block": "icons/svg-library/arrow-right-block.c411c.svg",
        "arrow-right-outline": "icons/svg-library/arrow-right-outline.2565b.svg",
        "arrow-right": "icons/svg-library/arrow-right.80bc0.svg",
        "arrow-up-block": "icons/svg-library/arrow-up-block.dcdaf.svg",
        "arrow-up-outline": "icons/svg-library/arrow-up-outline.80263.svg",
        "arrow-up": "icons/svg-library/arrow-up.79e25.svg",
        "attachment-block": "icons/svg-library/attachment-block.c9112.svg",
        "attachment-outline": "icons/svg-library/attachment-outline.62dc1.svg",
        "attachment": "icons/svg-library/attachment.c19a0.svg",
        "avios-currency": "icons/svg-library/avios-currency.946ab.svg",
        "avios-gift-card-block": "icons/svg-library/avios-gift-card-block.4de65.svg",
        "avios-gift-card-outline": "icons/svg-library/avios-gift-card-outline.51672.svg",
        "avios-gift-card": "icons/svg-library/avios-gift-card.55766.svg",
        "avios-mono": "icons/svg-library/avios-mono.397f5.svg",
        "avios-plectrum": "icons/svg-library/avios-plectrum.4daeb.svg",
        "b2b-block": "icons/svg-library/b2b-block.f36a8.svg",
        "b2b-outline": "icons/svg-library/b2b-outline.c729f.svg",
        "b2b": "icons/svg-library/b2b.33525.svg",
        "baby-bassinet-block": "icons/svg-library/baby-bassinet-block.28b6a.svg",
        "baby-bassinet-outline": "icons/svg-library/baby-bassinet-outline.17f87.svg",
        "baby-bassinet": "icons/svg-library/baby-bassinet.b59f2.svg",
        "backpack-block": "icons/svg-library/backpack-block.5bf39.svg",
        "backpack-outline": "icons/svg-library/backpack-outline.2ccf3.svg",
        "backpack": "icons/svg-library/backpack.d564e.svg",
        "baggage-checked-in-block": "icons/svg-library/baggage-checked-in-block.892ff.svg",
        "baggage-checked-in-outline": "icons/svg-library/baggage-checked-in-outline.954e6.svg",
        "baggage-checked-in": "icons/svg-library/baggage-checked-in.772a5.svg",
        "baggage-claim-block": "icons/svg-library/baggage-claim-block.7d748.svg",
        "baggage-claim-outline": "icons/svg-library/baggage-claim-outline.8d984.svg",
        "baggage-claim": "icons/svg-library/baggage-claim.60653.svg",
        "baggage-weight-block": "icons/svg-library/baggage-weight-block.baaa6.svg",
        "baggage-weight-outline": "icons/svg-library/baggage-weight-outline.0ea2a.svg",
        "baggage-weight": "icons/svg-library/baggage-weight.5034d.svg",
        "baggage-with-tag-block": "icons/svg-library/baggage-with-tag-block.88b40.svg",
        "baggage-with-tag-outline": "icons/svg-library/baggage-with-tag-outline.5a4ff.svg",
        "baggage-with-tag": "icons/svg-library/baggage-with-tag.68b0c.svg",
        "beer-block": "icons/svg-library/beer-block.197d1.svg",
        "beer-outline": "icons/svg-library/beer-outline.315d0.svg",
        "beer": "icons/svg-library/beer.d8c66.svg",
        "bike-block": "icons/svg-library/bike-block.d2a13.svg",
        "bike-outline": "icons/svg-library/bike-outline.bc20f.svg",
        "bike": "icons/svg-library/bike.783c9.svg",
        "blog-block": "icons/svg-library/blog-block.f94b2.svg",
        "blog-outline": "icons/svg-library/blog-outline.544a6.svg",
        "blog": "icons/svg-library/blog.e8f42.svg",
        "blueberry-juice-block": "icons/svg-library/blueberry-juice-block.ffeb4.svg",
        "blueberry-juice-outline": "icons/svg-library/blueberry-juice-outline.7195e.svg",
        "blueberry-juice": "icons/svg-library/blueberry-juice.ede8b.svg",
        "book-flight-block": "icons/svg-library/book-flight-block.c2fe7.svg",
        "book-flight-outline": "icons/svg-library/book-flight-outline.bb927.svg",
        "book-flight": "icons/svg-library/book-flight.aee45.svg",
        "breakfast-block": "icons/svg-library/breakfast-block.20641.svg",
        "breakfast-outline": "icons/svg-library/breakfast-outline.5c5c2.svg",
        "breakfast": "icons/svg-library/breakfast.312d6.svg",
        "brightness-block": "icons/svg-library/brightness-block.aa99b.svg",
        "brightness-low-block": "icons/svg-library/brightness-low-block.05e54.svg",
        "brightness-low-outline": "icons/svg-library/brightness-low-outline.3862e.svg",
        "brightness-low": "icons/svg-library/brightness-low.b5ec7.svg",
        "brightness-medium-block": "icons/svg-library/brightness-medium-block.50687.svg",
        "brightness-medium-outline": "icons/svg-library/brightness-medium-outline.a6aed.svg",
        "brightness-medium": "icons/svg-library/brightness-medium.86cf2.svg",
        "brightness-outline": "icons/svg-library/brightness-outline.4120e.svg",
        "brightness": "icons/svg-library/brightness.ee13f.svg",
        "bus-block": "icons/svg-library/bus-block.9bff2.svg",
        "bus-outline": "icons/svg-library/bus-outline.ad268.svg",
        "bus": "icons/svg-library/bus.297d0.svg",
        "business-class-block": "icons/svg-library/business-class-block.4cedc.svg",
        "business-class-outline": "icons/svg-library/business-class-outline.e40e2.svg",
        "business-class": "icons/svg-library/business-class.b38f9.svg",
        "calendar-block": "icons/svg-library/calendar-block.99f65.svg",
        "calendar-outline": "icons/svg-library/calendar-outline.5d1e7.svg",
        "calendar": "icons/svg-library/calendar.c324e.svg",
        "camera-block": "icons/svg-library/camera-block.5352a.svg",
        "camera-outline": "icons/svg-library/camera-outline.cac68.svg",
        "camera": "icons/svg-library/camera.8f2ba.svg",
        "car-block": "icons/svg-library/car-block.2dd7d.svg",
        "car-outline": "icons/svg-library/car-outline.ba120.svg",
        "car": "icons/svg-library/car.6d228.svg",
        "cargo": "icons/svg-library/cargo.ad5da.svg",
        "carry-on-bag-block": "icons/svg-library/carry-on-bag-block.0da81.svg",
        "carry-on-bag-outline": "icons/svg-library/carry-on-bag-outline.00a3d.svg",
        "carry-on-bag-trolley-block": "icons/svg-library/carry-on-bag-trolley-block.c4b9b.svg",
        "carry-on-bag-trolley-outline": "icons/svg-library/carry-on-bag-trolley-outline.62eb8.svg",
        "carry-on-bag-trolley": "icons/svg-library/carry-on-bag-trolley.cdc37.svg",
        "carry-on-bag": "icons/svg-library/carry-on-bag.a7566.svg",
        "carry-on-baggage-block": "icons/svg-library/carry-on-baggage-block.2bb18.svg",
        "carry-on-baggage-outline": "icons/svg-library/carry-on-baggage-outline.9752c.svg",
        "carry-on-baggage": "icons/svg-library/carry-on-baggage.b36e4.svg",
        "carry-on-prohibited": "icons/svg-library/carry-on-prohibited.b888c.svg",
        "chat-block": "icons/svg-library/chat-block.b95e0.svg",
        "chat-outline": "icons/svg-library/chat-outline.fea7b.svg",
        "chat": "icons/svg-library/chat.243b1.svg",
        "check-in-block": "icons/svg-library/check-in-block.6cde0.svg",
        "check-in-outline": "icons/svg-library/check-in-outline.41783.svg",
        "check-in": "icons/svg-library/check-in.13621.svg",
        "checkbox-selected-inverted": "icons/svg-library/checkbox-selected-inverted.137aa.svg",
        "checkbox-selected": "icons/svg-library/checkbox-selected.d8c03.svg",
        "checkbox-unselected-inverted": "icons/svg-library/checkbox-unselected-inverted.6bbaf.svg",
        "checkbox-unselected": "icons/svg-library/checkbox-unselected.8f5e4.svg",
        "checked-bag-prohibited": "icons/svg-library/checked-bag-prohibited.e28f9.svg",
        "checked-baggage-block": "icons/svg-library/checked-baggage-block.3d3e5.svg",
        "checked-baggage-outline": "icons/svg-library/checked-baggage-outline.4f48b.svg",
        "checked-baggage": "icons/svg-library/checked-baggage.1b55d.svg",
        "checked-in-baggage-block": "icons/svg-library/checked-in-baggage-block.77962.svg",
        "checked-in-baggage-none-block": "icons/svg-library/checked-in-baggage-none-block.5483b.svg",
        "checked-in-baggage-none-outline": "icons/svg-library/checked-in-baggage-none-outline.a90b9.svg",
        "checked-in-baggage-none": "icons/svg-library/checked-in-baggage-none.b6ce2.svg",
        "checked-in-baggage-outline": "icons/svg-library/checked-in-baggage-outline.954e6.svg",
        "checked-in-baggage": "icons/svg-library/checked-in-baggage.2a67f.svg",
        "checklist-block": "icons/svg-library/checklist-block.b548d.svg",
        "checklist-outline": "icons/svg-library/checklist-outline.f8ebc.svg",
        "checklist": "icons/svg-library/checklist.49817.svg",
        "checkmark-block": "icons/svg-library/checkmark-block.5aa44.svg",
        "checkmark-button-selected": "icons/svg-library/checkmark-button-selected.b3a54.svg",
        "checkmark-button-unselected": "icons/svg-library/checkmark-button-unselected.016f9.svg",
        "checkmark-outline": "icons/svg-library/checkmark-outline.af396.svg",
        "checkmark": "icons/svg-library/checkmark.4bd04.svg",
        "chevron-down-block": "icons/svg-library/chevron-down-block.dbdee.svg",
        "chevron-down-outline": "icons/svg-library/chevron-down-outline.f2e83.svg",
        "chevron-down": "icons/svg-library/chevron-down.8ea56.svg",
        "chevron-left-block": "icons/svg-library/chevron-left-block.cde08.svg",
        "chevron-left-outline": "icons/svg-library/chevron-left-outline.fb5d8.svg",
        "chevron-left": "icons/svg-library/chevron-left.eb870.svg",
        "chevron-right-block": "icons/svg-library/chevron-right-block.0697d.svg",
        "chevron-right-outline": "icons/svg-library/chevron-right-outline.83752.svg",
        "chevron-right": "icons/svg-library/chevron-right.724ea.svg",
        "chevron-up-block": "icons/svg-library/chevron-up-block.1d5f0.svg",
        "chevron-up-outline": "icons/svg-library/chevron-up-outline.86ac5.svg",
        "chevron-up": "icons/svg-library/chevron-up.10188.svg",
        "child-block": "icons/svg-library/child-block.43d21.svg",
        "child-outline": "icons/svg-library/child-outline.d94c5.svg",
        "child": "icons/svg-library/child.c3f68.svg",
        "clock": "icons/svg-library/clock.05f9c.svg",
        "close-delete-block": "icons/svg-library/close-delete-block.93e0f.svg",
        "close-delete-outline": "icons/svg-library/close-delete-outline.29aa4.svg",
        "close-delete": "icons/svg-library/close-delete.d9435.svg",
        "co2-block": "icons/svg-library/co2-block.544e6.svg",
        "co2-outline": "icons/svg-library/co2-outline.083a0.svg",
        "co2": "icons/svg-library/co2.c6e85.svg",
        "coffee-block": "icons/svg-library/coffee-block.61152.svg",
        "coffee-outline": "icons/svg-library/coffee-outline.77f3b.svg",
        "coffee": "icons/svg-library/coffee.02c35.svg",
        "connecting-flight-block": "icons/svg-library/connecting-flight-block.79b49.svg",
        "connecting-flight-outline": "icons/svg-library/connecting-flight-outline.d4efd.svg",
        "connecting-flight": "icons/svg-library/connecting-flight.cb727.svg",
        "copy-block": "icons/svg-library/copy-block.ebce6.svg",
        "copy-outline": "icons/svg-library/copy-outline.22417.svg",
        "copy": "icons/svg-library/copy.6d2b4.svg",
        "corporate-booking-block": "icons/svg-library/corporate-booking-block.cc8bb.svg",
        "corporate-booking-outline": "icons/svg-library/corporate-booking-outline.6b07a.svg",
        "corporate-booking": "icons/svg-library/corporate-booking.175b8.svg",
        "corrosives-prohibited": "icons/svg-library/corrosives-prohibited.2128b.svg",
        "corrosives": "icons/svg-library/corrosives.8f6e0.svg",
        "couple-block": "icons/svg-library/couple-block.c95f6.svg",
        "couple-outline": "icons/svg-library/couple-outline.0af92.svg",
        "couple": "icons/svg-library/couple.a30ec.svg",
        "credit-or-debit-card-block": "icons/svg-library/credit-or-debit-card-block.b23dd.svg",
        "credit-or-debit-card-outline": "icons/svg-library/credit-or-debit-card-outline.20284.svg",
        "credit-or-debit-card": "icons/svg-library/credit-or-debit-card.897cc.svg",
        "crew-called-block": "icons/svg-library/crew-called-block.4e57c.svg",
        "crew-called-outline": "icons/svg-library/crew-called-outline.87039.svg",
        "crew-called": "icons/svg-library/crew-called.640bf.svg",
        "currency-block": "icons/svg-library/currency-block.43622.svg",
        "currency-outline": "icons/svg-library/currency-outline.9afee.svg",
        "currency": "icons/svg-library/currency.61ae6.svg",
        "customer-service-block": "icons/svg-library/customer-service-block.54812.svg",
        "customer-service-outline": "icons/svg-library/customer-service-outline.47bf4.svg",
        "customer-service": "icons/svg-library/customer-service.08d84.svg",
        "day-block": "icons/svg-library/day-block.d96ec.svg",
        "day-outline": "icons/svg-library/day-outline.785ee.svg",
        "day": "icons/svg-library/day.4ca54.svg",
        "departure-block": "icons/svg-library/departure-block.f8781.svg",
        "departure-gate-block": "icons/svg-library/departure-gate-block.fb8ac.svg",
        "departure-gate-outline": "icons/svg-library/departure-gate-outline.5a925.svg",
        "departure-gate": "icons/svg-library/departure-gate.37651.svg",
        "departure-outline": "icons/svg-library/departure-outline.e4402.svg",
        "departure": "icons/svg-library/departure.fe2fd.svg",
        "destination-block": "icons/svg-library/destination-block.03cb3.svg",
        "destination-outline": "icons/svg-library/destination-outline.07edc.svg",
        "destination": "icons/svg-library/destination.9bb02.svg",
        "discount-block": "icons/svg-library/discount-block.e6f66.svg",
        "discount-outline": "icons/svg-library/discount-outline.638dd.svg",
        "discount": "icons/svg-library/discount.3d685.svg",
        "discounted-price-block": "icons/svg-library/discounted-price-block.d5452.svg",
        "discounted-price-outline": "icons/svg-library/discounted-price-outline.6e499.svg",
        "discounted-price": "icons/svg-library/discounted-price.d37c2.svg",
        "dog-block": "icons/svg-library/dog-block.a7a4c.svg",
        "dog-outline": "icons/svg-library/dog-outline.9f091.svg",
        "dog": "icons/svg-library/dog.7a6a9.svg",
        "donation-block": "icons/svg-library/donation-block.75089.svg",
        "donation-outline": "icons/svg-library/donation-outline.2379f.svg",
        "donation": "icons/svg-library/donation.5ad92.svg",
        "download-block": "icons/svg-library/download-block.ed254.svg",
        "download-outline": "icons/svg-library/download-outline.c1ad1.svg",
        "download": "icons/svg-library/download.8877a.svg",
        "drink-soda-block": "icons/svg-library/drink-soda-block.0b043.svg",
        "drink-soda-outline": "icons/svg-library/drink-soda-outline.99f0f.svg",
        "drink-soda": "icons/svg-library/drink-soda.2733d.svg",
        "e-cigarette-prohibited": "icons/svg-library/e-cigarette-prohibited.a11f4.svg",
        "e-cigarette": "icons/svg-library/e-cigarette.a43d4.svg",
        "edit-block": "icons/svg-library/edit-block.17eb8.svg",
        "edit-outline": "icons/svg-library/edit-outline.9c112.svg",
        "edit": "icons/svg-library/edit.d7648.svg",
        "eight-block": "icons/svg-library/eight-block.e3ce0.svg",
        "eight-outline": "icons/svg-library/eight-outline.7464a.svg",
        "eight": "icons/svg-library/eight.7eb14.svg",
        "electric-socket-block": "icons/svg-library/electric-socket-block.eb327.svg",
        "electric-socket-outline": "icons/svg-library/electric-socket-outline.62e15.svg",
        "electric-socket": "icons/svg-library/electric-socket.d813e.svg",
        "email-block": "icons/svg-library/email-block.18b77.svg",
        "email-outline": "icons/svg-library/email-outline.d90f8.svg",
        "email": "icons/svg-library/email.3aeee.svg",
        "empty": "icons/svg-library/empty.6f72f.svg",
        "expand-block": "icons/svg-library/expand-block.a6d73.svg",
        "expand-outline": "icons/svg-library/expand-outline.9850f.svg",
        "expand": "icons/svg-library/expand.ac7be.svg",
        "explosives-prohibited": "icons/svg-library/explosives-prohibited.94df1.svg",
        "explosives": "icons/svg-library/explosives.ba37a.svg",
        "external-tab-block": "icons/svg-library/external-tab-block.4f2c2.svg",
        "external-tab-outline": "icons/svg-library/external-tab-outline.154f2.svg",
        "external-tab": "icons/svg-library/external-tab.c4d59.svg",
        "extra-carry-on-bag-block": "icons/svg-library/extra-carry-on-bag-block.a65f1.svg",
        "extra-carry-on-bag-outline": "icons/svg-library/extra-carry-on-bag-outline.4f282.svg",
        "extra-carry-on-bag": "icons/svg-library/extra-carry-on-bag.98e07.svg",
        "extra-check-in-baggage-block": "icons/svg-library/extra-check-in-baggage-block.7ddbd.svg",
        "extra-check-in-baggage-outline": "icons/svg-library/extra-check-in-baggage-outline.b57be.svg",
        "extra-check-in-baggage": "icons/svg-library/extra-check-in-baggage.d31ec.svg",
        "extra-leg-room-block": "icons/svg-library/extra-leg-room-block.63be5.svg",
        "extra-leg-room-outline": "icons/svg-library/extra-leg-room-outline.df9d6.svg",
        "extra-leg-room": "icons/svg-library/extra-leg-room.a7f8b.svg",
        "facebook-block": "icons/svg-library/facebook-block.5484c.svg",
        "facebook-outline": "icons/svg-library/facebook-outline.acc7b.svg",
        "facebook": "icons/svg-library/facebook.2627d.svg",
        "facemask-block": "icons/svg-library/facemask-block.d8c47.svg",
        "facemask-outline": "icons/svg-library/facemask-outline.1fb24.svg",
        "facemask": "icons/svg-library/facemask.31cfb.svg",
        "family-block": "icons/svg-library/family-block.d56a6.svg",
        "family-outline": "icons/svg-library/family-outline.6699a.svg",
        "family": "icons/svg-library/family.f4a60.svg",
        "favourite-entertainment-block": "icons/svg-library/favourite-entertainment-block.fe5d6.svg",
        "favourite-entertainment-outline": "icons/svg-library/favourite-entertainment-outline.82cb4.svg",
        "favourite-entertainment": "icons/svg-library/favourite-entertainment.ea5b6.svg",
        "filter-options-block": "icons/svg-library/filter-options-block.3d87c.svg",
        "filter-options-outline": "icons/svg-library/filter-options-outline.3d8be.svg",
        "filter-options": "icons/svg-library/filter-options.3c7bd.svg",
        "finland-block": "icons/svg-library/finland-block.c1edf.svg",
        "finland-outline": "icons/svg-library/finland-outline.6e5b8.svg",
        "finland": "icons/svg-library/finland.95aea.svg",
        "finnair-emblem-block": "icons/svg-library/finnair-emblem-block.45bfe.svg",
        "finnair-emblem-outline": "icons/svg-library/finnair-emblem-outline.47b99.svg",
        "finnair-emblem": "icons/svg-library/finnair-emblem.fbc09.svg",
        "finnair-plus-block": "icons/svg-library/finnair-plus-block.89d2b.svg",
        "finnair-plus-card-block": "icons/svg-library/finnair-plus-card-block.4de82.svg",
        "finnair-plus-card-outline": "icons/svg-library/finnair-plus-card-outline.73403.svg",
        "finnair-plus-card": "icons/svg-library/finnair-plus-card.b665d.svg",
        "finnair-plus-outline": "icons/svg-library/finnair-plus-outline.741d5.svg",
        "finnair-plus": "icons/svg-library/finnair-plus.06769.svg",
        "fire-arms-prohibited": "icons/svg-library/fire-arms-prohibited.91c7f.svg",
        "fire-arms": "icons/svg-library/fire-arms.3082e.svg",
        "five-block": "icons/svg-library/five-block.8509e.svg",
        "five-outline": "icons/svg-library/five-outline.ef975.svg",
        "five": "icons/svg-library/five.e67e0.svg",
        "flammable-gases-prohibited": "icons/svg-library/flammable-gases-prohibited.9b0b9.svg",
        "flammable-gases": "icons/svg-library/flammable-gases.34b15.svg",
        "flammable-liquids-prohibited": "icons/svg-library/flammable-liquids-prohibited.344c0.svg",
        "flammable-liquids": "icons/svg-library/flammable-liquids.773fc.svg",
        "flammable-solids-prohibited": "icons/svg-library/flammable-solids-prohibited.dec4f.svg",
        "flammable-solids": "icons/svg-library/flammable-solids.9c2c3.svg",
        "flight-camera-block": "icons/svg-library/flight-camera-block.f9df1.svg",
        "flight-camera-outline": "icons/svg-library/flight-camera-outline.ffc6b.svg",
        "flight-camera": "icons/svg-library/flight-camera.50bb4.svg",
        "flight-hotel": "icons/svg-library/flight-hotel.21c4f.svg",
        "flight-map-block": "icons/svg-library/flight-map-block.fa856.svg",
        "flight-map-outline": "icons/svg-library/flight-map-outline.8d7af.svg",
        "flight-map": "icons/svg-library/flight-map.f1fc4.svg",
        "flight-offer-block": "icons/svg-library/flight-offer-block.bbf3f.svg",
        "flight-offer-outline": "icons/svg-library/flight-offer-outline.a3bb2.svg",
        "flight-offer": "icons/svg-library/flight-offer.3b3f2.svg",
        "flight-status": "icons/svg-library/flight-status.4f1a6.svg",
        "flights-unavailable-block": "icons/svg-library/flights-unavailable-block.4dc24.svg",
        "flights-unavailable-outline": "icons/svg-library/flights-unavailable-outline.62eed.svg",
        "flights-unavailable": "icons/svg-library/flights-unavailable.d1dab.svg",
        "food-block": "icons/svg-library/food-block.a2181.svg",
        "food-outline": "icons/svg-library/food-outline.7b0d4.svg",
        "food": "icons/svg-library/food.0d5ec.svg",
        "four-block": "icons/svg-library/four-block.e0ab6.svg",
        "four-outline": "icons/svg-library/four-outline.230b4.svg",
        "four": "icons/svg-library/four.47edf.svg",
        "games-block": "icons/svg-library/games-block.1ecd7.svg",
        "games-outline": "icons/svg-library/games-outline.21cd7.svg",
        "games": "icons/svg-library/games.47596.svg",
        "gift-card-block": "icons/svg-library/gift-card-block.81b24.svg",
        "gift-card-outline": "icons/svg-library/gift-card-outline.79007.svg",
        "gift-card": "icons/svg-library/gift-card.637d9.svg",
        "golf-block": "icons/svg-library/golf-block.a8bb5.svg",
        "golf-outline": "icons/svg-library/golf-outline.a0a44.svg",
        "golf-skis-block": "icons/svg-library/golf-skis-block.a9f62.svg",
        "golf-skis-outline": "icons/svg-library/golf-skis-outline.bfaec.svg",
        "golf-skis": "icons/svg-library/golf-skis.fe3d9.svg",
        "golf": "icons/svg-library/golf.b5548.svg",
        "gps-location-block": "icons/svg-library/gps-location-block.f13eb.svg",
        "gps-location-outline": "icons/svg-library/gps-location-outline.fcfe1.svg",
        "gps-location": "icons/svg-library/gps-location.400db.svg",
        "group-block": "icons/svg-library/group-block.244b2.svg",
        "group-outline": "icons/svg-library/group-outline.3eddf.svg",
        "group": "icons/svg-library/group.28343.svg",
        "headphones-block": "icons/svg-library/headphones-block.79599.svg",
        "headphones-outline": "icons/svg-library/headphones-outline.7b985.svg",
        "headphones": "icons/svg-library/headphones.457c9.svg",
        "help-block": "icons/svg-library/help-block.f51e7.svg",
        "help-outline": "icons/svg-library/help-outline.63170.svg",
        "help": "icons/svg-library/help.fb9a6.svg",
        "hold-my-booking-block": "icons/svg-library/hold-my-booking-block.44cee.svg",
        "hold-my-booking-outline": "icons/svg-library/hold-my-booking-outline.bfba3.svg",
        "hold-my-booking": "icons/svg-library/hold-my-booking.540f8.svg",
        "home-block": "icons/svg-library/home-block.85217.svg",
        "home-outline": "icons/svg-library/home-outline.359b2.svg",
        "home": "icons/svg-library/home.f7ea7.svg",
        "hotel-block": "icons/svg-library/hotel-block.2b184.svg",
        "hotel-outline": "icons/svg-library/hotel-outline.9e94a.svg",
        "hotel": "icons/svg-library/hotel.78a8d.svg",
        "in-coming-call-block": "icons/svg-library/in-coming-call-block.f97a7.svg",
        "in-coming-call-outline": "icons/svg-library/in-coming-call-outline.0c9e0.svg",
        "in-coming-call": "icons/svg-library/in-coming-call.7d862.svg",
        "infant-block": "icons/svg-library/infant-block.f526c.svg",
        "infant-outline": "icons/svg-library/infant-outline.a22ba.svg",
        "infant": "icons/svg-library/infant.541fe.svg",
        "info-block": "icons/svg-library/info-block.78151.svg",
        "info-outline": "icons/svg-library/info-outline.51434.svg",
        "info": "icons/svg-library/info.f1043.svg",
        "instagram": "icons/svg-library/instagram.512e7.svg",
        "insurance-block": "icons/svg-library/insurance-block.6b2c6.svg",
        "insurance-outline": "icons/svg-library/insurance-outline.e59fe.svg",
        "insurance": "icons/svg-library/insurance.6a46d.svg",
        "internet-disruption": "icons/svg-library/internet-disruption.7faa6.svg",
        "keyboard-block": "icons/svg-library/keyboard-block.f8ce9.svg",
        "keyboard-outline": "icons/svg-library/keyboard-outline.ca75d.svg",
        "keyboard": "icons/svg-library/keyboard.2b185.svg",
        "language-block": "icons/svg-library/language-block.15705.svg",
        "language-outline": "icons/svg-library/language-outline.6229a.svg",
        "language": "icons/svg-library/language.76f50.svg",
        "laptop-block": "icons/svg-library/laptop-block.182ba.svg",
        "laptop-outline": "icons/svg-library/laptop-outline.cf337.svg",
        "laptop": "icons/svg-library/laptop.2cd7b.svg",
        "lavatory-block": "icons/svg-library/lavatory-block.828e7.svg",
        "lavatory-men-block": "icons/svg-library/lavatory-men-block.b7e1f.svg",
        "lavatory-men-outline": "icons/svg-library/lavatory-men-outline.068da.svg",
        "lavatory-men": "icons/svg-library/lavatory-men.53855.svg",
        "lavatory-outline": "icons/svg-library/lavatory-outline.43568.svg",
        "lavatory-women-block": "icons/svg-library/lavatory-women-block.05535.svg",
        "lavatory-women-outline": "icons/svg-library/lavatory-women-outline.cc479.svg",
        "lavatory-women": "icons/svg-library/lavatory-women.5a58d.svg",
        "lavatory": "icons/svg-library/lavatory.32e89.svg",
        "legislation-block": "icons/svg-library/legislation-block.6ee77.svg",
        "legislation-outline": "icons/svg-library/legislation-outline.9f975.svg",
        "legislation": "icons/svg-library/legislation.33dff.svg",
        "lighters-matches-prohibited": "icons/svg-library/lighters-matches-prohibited.76667.svg",
        "lighters-matches": "icons/svg-library/lighters-matches.a1c1a.svg",
        "lighters-prohibited": "icons/svg-library/lighters-prohibited.3d796.svg",
        "lighters": "icons/svg-library/lighters.571a0.svg",
        "lights-off-block": "icons/svg-library/lights-off-block.cd71a.svg",
        "lights-off-outline": "icons/svg-library/lights-off-outline.4a68d.svg",
        "lights-off": "icons/svg-library/lights-off.a0c37.svg",
        "lights-on-block": "icons/svg-library/lights-on-block.37777.svg",
        "lights-on-outline": "icons/svg-library/lights-on-outline.da13d.svg",
        "lights-on": "icons/svg-library/lights-on.a3256.svg",
        "link-block": "icons/svg-library/link-block.a3ee8.svg",
        "link-outline": "icons/svg-library/link-outline.f10c4.svg",
        "link": "icons/svg-library/link.4a034.svg",
        "linkedin-block": "icons/svg-library/linkedin-block.c4d6c.svg",
        "linkedin-outline": "icons/svg-library/linkedin-outline.49e70.svg",
        "linkedin": "icons/svg-library/linkedin.3c451.svg",
        "liquid-container": "icons/svg-library/liquid-container.2cd2a.svg",
        "lock-active-block": "icons/svg-library/lock-active-block.027a3.svg",
        "lock-active-outline": "icons/svg-library/lock-active-outline.450f7.svg",
        "lock-active": "icons/svg-library/lock-active.aa2bb.svg",
        "lock-closed-block": "icons/svg-library/lock-closed-block.8dad5.svg",
        "lock-closed-outline": "icons/svg-library/lock-closed-outline.daaa9.svg",
        "lock-closed": "icons/svg-library/lock-closed.760f5.svg",
        "lock-open-block": "icons/svg-library/lock-open-block.492e8.svg",
        "lock-open-outline": "icons/svg-library/lock-open-outline.5bcdd.svg",
        "lock-open": "icons/svg-library/lock-open.add62.svg",
        "locker-block": "icons/svg-library/locker-block.84702.svg",
        "locker-outline": "icons/svg-library/locker-outline.5d68d.svg",
        "locker": "icons/svg-library/locker.94a75.svg",
        "logged-in-block": "icons/svg-library/logged-in-block.50510.svg",
        "logged-in-outline": "icons/svg-library/logged-in-outline.4a0cf.svg",
        "logged-in": "icons/svg-library/logged-in.ee1ec.svg",
        "logout-block": "icons/svg-library/logout-block.43956.svg",
        "logout-outline": "icons/svg-library/logout-outline.2051b.svg",
        "logout": "icons/svg-library/logout.743d7.svg",
        "lost-baggage": "icons/svg-library/lost-baggage.7d7b5.svg",
        "lost-card": "icons/svg-library/lost-card.027b9.svg",
        "lounge-block": "icons/svg-library/lounge-block.c859c.svg",
        "lounge-outline": "icons/svg-library/lounge-outline.e497a.svg",
        "lounge": "icons/svg-library/lounge.f1785.svg",
        "magazines-block": "icons/svg-library/magazines-block.3464c.svg",
        "magazines-outline": "icons/svg-library/magazines-outline.6f449.svg",
        "magazines": "icons/svg-library/magazines.37a00.svg",
        "map-layers-block": "icons/svg-library/map-layers-block.d84c3.svg",
        "map-layers-outline": "icons/svg-library/map-layers-outline.8e272.svg",
        "map-layers": "icons/svg-library/map-layers.5df34.svg",
        "meal-block": "icons/svg-library/meal-block.6148a.svg",
        "meal-outline": "icons/svg-library/meal-outline.70c0a.svg",
        "meal": "icons/svg-library/meal.1a8c1.svg",
        "medical-assistance-block": "icons/svg-library/medical-assistance-block.176c4.svg",
        "medical-assistance-outline": "icons/svg-library/medical-assistance-outline.7ec39.svg",
        "medical-assistance": "icons/svg-library/medical-assistance.46f2d.svg",
        "menu-grid-block": "icons/svg-library/menu-grid-block.ed000.svg",
        "menu-grid-outline": "icons/svg-library/menu-grid-outline.becdd.svg",
        "menu-grid": "icons/svg-library/menu-grid.53b4e.svg",
        "menu-list-block": "icons/svg-library/menu-list-block.e7478.svg",
        "menu-list-outline": "icons/svg-library/menu-list-outline.fb533.svg",
        "menu-list-view-block": "icons/svg-library/menu-list-view-block.0d8be.svg",
        "menu-list-view-outline": "icons/svg-library/menu-list-view-outline.592c7.svg",
        "menu-list-view": "icons/svg-library/menu-list-view.e926b.svg",
        "menu-list": "icons/svg-library/menu-list.f4529.svg",
        "milestone-block": "icons/svg-library/milestone-block.f81e5.svg",
        "milestone-outline": "icons/svg-library/milestone-outline.ad3ba.svg",
        "milestone": "icons/svg-library/milestone.17bb5.svg",
        "minimise-block": "icons/svg-library/minimise-block.e4524.svg",
        "minimise-chat": "icons/svg-library/minimise-chat.6f5db.svg",
        "minimise-outline": "icons/svg-library/minimise-outline.9b152.svg",
        "minimise": "icons/svg-library/minimise.17832.svg",
        "minus-block": "icons/svg-library/minus-block.5d150.svg",
        "minus-outline": "icons/svg-library/minus-outline.36be9.svg",
        "minus": "icons/svg-library/minus.55ece.svg",
        "mmb-ticket-changes-block": "icons/svg-library/mmb-ticket-changes-block.9fd3b.svg",
        "mmb-ticket-changes-outline": "icons/svg-library/mmb-ticket-changes-outline.b2401.svg",
        "mmb-ticket-changes": "icons/svg-library/mmb-ticket-changes.6a4b4.svg",
        "mobile-phone-block": "icons/svg-library/mobile-phone-block.1ed1a.svg",
        "mobile-phone-outline": "icons/svg-library/mobile-phone-outline.bcf7a.svg",
        "mobile-phone": "icons/svg-library/mobile-phone.0631c.svg",
        "more-block": "icons/svg-library/more-block.e8d11.svg",
        "more-outline": "icons/svg-library/more-outline.efbdd.svg",
        "more": "icons/svg-library/more.2c919.svg",
        "movies-block": "icons/svg-library/movies-block.2a496.svg",
        "movies-outline": "icons/svg-library/movies-outline.7a437.svg",
        "movies": "icons/svg-library/movies.ce4af.svg",
        "multi-pax-block": "icons/svg-library/multi-pax-block.2ba22.svg",
        "multi-pax-outline": "icons/svg-library/multi-pax-outline.ceaa3.svg",
        "multi-pax": "icons/svg-library/multi-pax.b6d8f.svg",
        "multistop-block": "icons/svg-library/multistop-block.9d8a6.svg",
        "multistop-outline": "icons/svg-library/multistop-outline.7be30.svg",
        "multistop": "icons/svg-library/multistop.2de6c.svg",
        "music-block": "icons/svg-library/music-block.da933.svg",
        "music-outline": "icons/svg-library/music-outline.7a6ad.svg",
        "music": "icons/svg-library/music.6c288.svg",
        "night-block": "icons/svg-library/night-block.f028c.svg",
        "night-outline": "icons/svg-library/night-outline.fc26b.svg",
        "night": "icons/svg-library/night.f675b.svg",
        "nine-block": "icons/svg-library/nine-block.00f61.svg",
        "nine-outline": "icons/svg-library/nine-outline.da09a.svg",
        "nine": "icons/svg-library/nine.f69a1.svg",
        "nordic-product-block": "icons/svg-library/nordic-product-block.ffe2f.svg",
        "nordic-product-outline": "icons/svg-library/nordic-product-outline.3fff4.svg",
        "nordic-product": "icons/svg-library/nordic-product.acaaa.svg",
        "not-visible-block": "icons/svg-library/not-visible-block.5f2b9.svg",
        "not-visible-outline": "icons/svg-library/not-visible-outline.3e442.svg",
        "not-visible": "icons/svg-library/not-visible.1b706.svg",
        "onboard-safety-block": "icons/svg-library/onboard-safety-block.a3bb0.svg",
        "onboard-safety-outline": "icons/svg-library/onboard-safety-outline.27de3.svg",
        "onboard-safety": "icons/svg-library/onboard-safety.a02ee.svg",
        "onboard-service-block": "icons/svg-library/onboard-service-block.47173.svg",
        "onboard-service-outline": "icons/svg-library/onboard-service-outline.5a499.svg",
        "onboard-service": "icons/svg-library/onboard-service.d7ac1.svg",
        "one-block": "icons/svg-library/one-block.0a133.svg",
        "one-outline": "icons/svg-library/one-outline.807ac.svg",
        "one": "icons/svg-library/one.9ba68.svg",
        "oneworld-logo": "icons/svg-library/oneworld-logo.1471e.svg",
        "online-checked-block": "icons/svg-library/online-checked-block.adddd.svg",
        "online-checked-outline": "icons/svg-library/online-checked-outline.12db1.svg",
        "online-checked": "icons/svg-library/online-checked.0d964.svg",
        "parking": "icons/svg-library/parking.2e0b7.svg",
        "pause-block": "icons/svg-library/pause-block.94e06.svg",
        "pause-outline": "icons/svg-library/pause-outline.f1b3f.svg",
        "pause": "icons/svg-library/pause.cd61b.svg",
        "payment-methods-block": "icons/svg-library/payment-methods-block.5e6ed.svg",
        "payment-methods-outline": "icons/svg-library/payment-methods-outline.db46b.svg",
        "payment-methods": "icons/svg-library/payment-methods.234ac.svg",
        "person-block": "icons/svg-library/person-block.98abc.svg",
        "person-outline": "icons/svg-library/person-outline.7dad4.svg",
        "person-special-assist-block": "icons/svg-library/person-special-assist-block.14b1c.svg",
        "person-special-assist-outline": "icons/svg-library/person-special-assist-outline.91cb8.svg",
        "person-special-assist": "icons/svg-library/person-special-assist.5723c.svg",
        "person-walking-block": "icons/svg-library/person-walking-block.cb637.svg",
        "person-walking-outline": "icons/svg-library/person-walking-outline.41665.svg",
        "person-walking": "icons/svg-library/person-walking.4f824.svg",
        "person-wheelchair-block": "icons/svg-library/person-wheelchair-block.d9928.svg",
        "person-wheelchair-outline": "icons/svg-library/person-wheelchair-outline.6c247.svg",
        "person-wheelchair": "icons/svg-library/person-wheelchair.6d23f.svg",
        "person": "icons/svg-library/person.0587b.svg",
        "pet-in-bag-block": "icons/svg-library/pet-in-bag-block.c2737.svg",
        "pet-in-bag-outline": "icons/svg-library/pet-in-bag-outline.d19b6.svg",
        "pet-in-bag": "icons/svg-library/pet-in-bag.76eda.svg",
        "pet": "icons/svg-library/pet.71c4d.svg",
        "phone-block": "icons/svg-library/phone-block.a8738.svg",
        "phone-outline": "icons/svg-library/phone-outline.1aea3.svg",
        "phone": "icons/svg-library/phone.4decf.svg",
        "picture-block": "icons/svg-library/picture-block.b89fc.svg",
        "picture-outline": "icons/svg-library/picture-outline.2d3cd.svg",
        "picture": "icons/svg-library/picture.b576a.svg",
        "play-block": "icons/svg-library/play-block.92dc4.svg",
        "play-next-block": "icons/svg-library/play-next-block.82555.svg",
        "play-next-outline": "icons/svg-library/play-next-outline.1941d.svg",
        "play-next": "icons/svg-library/play-next.4053b.svg",
        "play-outline": "icons/svg-library/play-outline.2a926.svg",
        "play-previous-block": "icons/svg-library/play-previous-block.55d9f.svg",
        "play-previous-outline": "icons/svg-library/play-previous-outline.e94bb.svg",
        "play-previous": "icons/svg-library/play-previous.46823.svg",
        "play": "icons/svg-library/play.5df91.svg",
        "plus-block": "icons/svg-library/plus-block.c1388.svg",
        "plus-outline": "icons/svg-library/plus-outline.f1601.svg",
        "plus": "icons/svg-library/plus.79da3.svg",
        "points-of-interest-block": "icons/svg-library/points-of-interest-block.69574.svg",
        "points-of-interest-outline": "icons/svg-library/points-of-interest-outline.71e94.svg",
        "points-of-interest": "icons/svg-library/points-of-interest.e15dc.svg",
        "poison-prohibited": "icons/svg-library/poison-prohibited.ecb63.svg",
        "poison": "icons/svg-library/poison.a6967.svg",
        "power-bank-block": "icons/svg-library/power-bank-block.03b2e.svg",
        "power-bank-outline": "icons/svg-library/power-bank-outline.db33b.svg",
        "power-bank-prohibited": "icons/svg-library/power-bank-prohibited.4c94a.svg",
        "power-bank": "icons/svg-library/power-bank.fb73a.svg",
        "power-block": "icons/svg-library/power-block.260a6.svg",
        "power-outline": "icons/svg-library/power-outline.2dfe1.svg",
        "power": "icons/svg-library/power.a6fb2.svg",
        "pre-order-block": "icons/svg-library/pre-order-block.bddf4.svg",
        "pre-order-outline": "icons/svg-library/pre-order-outline.0d2c9.svg",
        "pre-order": "icons/svg-library/pre-order.979de.svg",
        "premium-economy-block": "icons/svg-library/premium-economy-block.84eae.svg",
        "premium-economy-outline": "icons/svg-library/premium-economy-outline.929c9.svg",
        "premium-economy": "icons/svg-library/premium-economy.848ac.svg",
        "price-block": "icons/svg-library/price-block.33df7.svg",
        "price-outline": "icons/svg-library/price-outline.b4066.svg",
        "price": "icons/svg-library/price.f4385.svg",
        "print-bag-tag-block": "icons/svg-library/print-bag-tag-block.f6060.svg",
        "print-bag-tag-outline": "icons/svg-library/print-bag-tag-outline.b5525.svg",
        "print-bag-tag": "icons/svg-library/print-bag-tag.55f00.svg",
        "priority-check-in-block": "icons/svg-library/priority-check-in-block.05f73.svg",
        "priority-check-in-outline": "icons/svg-library/priority-check-in-outline.f537d.svg",
        "priority-check-in": "icons/svg-library/priority-check-in.8bc64.svg",
        "priority-security-block": "icons/svg-library/priority-security-block.b3aa2.svg",
        "priority-security-outline": "icons/svg-library/priority-security-outline.29e83.svg",
        "priority-security": "icons/svg-library/priority-security.e58ae.svg",
        "qrcode-block": "icons/svg-library/qrcode-block.961ec.svg",
        "qrcode-outline": "icons/svg-library/qrcode-outline.d16a5.svg",
        "qrcode": "icons/svg-library/qrcode.3ccf9.svg",
        "radio-selected": "icons/svg-library/radio-selected.0ef06.svg",
        "radio-unselected": "icons/svg-library/radio-unselected.5ea56.svg",
        "radioactive-prohibited": "icons/svg-library/radioactive-prohibited.b563d.svg",
        "radioactive": "icons/svg-library/radioactive.afab8.svg",
        "radiobutton-inverted-filled": "icons/svg-library/radiobutton-inverted-filled.fefcc.svg",
        "re-focus-block": "icons/svg-library/re-focus-block.43473.svg",
        "re-focus-outline": "icons/svg-library/re-focus-outline.67f07.svg",
        "re-focus": "icons/svg-library/re-focus.61948.svg",
        "rental-car-block": "icons/svg-library/rental-car-block.7592f.svg",
        "rental-car-outline": "icons/svg-library/rental-car-outline.2f1e8.svg",
        "rental-car": "icons/svg-library/rental-car.b898c.svg",
        "reservation-block": "icons/svg-library/reservation-block.19dfd.svg",
        "reservation-outline": "icons/svg-library/reservation-outline.b764a.svg",
        "reservation": "icons/svg-library/reservation.d7b73.svg",
        "rest-block": "icons/svg-library/rest-block.f42b3.svg",
        "rest-outline": "icons/svg-library/rest-outline.b9370.svg",
        "rest": "icons/svg-library/rest.f5c48.svg",
        "return-trip-block": "icons/svg-library/return-trip-block.c4050.svg",
        "return-trip-outline": "icons/svg-library/return-trip-outline.199c5.svg",
        "return-trip": "icons/svg-library/return-trip.f13a5.svg",
        "ride-share-block": "icons/svg-library/ride-share-block.56144.svg",
        "ride-share-outline": "icons/svg-library/ride-share-outline.4ee2c.svg",
        "ride-share": "icons/svg-library/ride-share.aefb0.svg",
        "saf-block": "icons/svg-library/saf-block.b73e5.svg",
        "saf-outline": "icons/svg-library/saf-outline.73c6d.svg",
        "saf": "icons/svg-library/saf.4e769.svg",
        "save-time": "icons/svg-library/save-time.9ad71.svg",
        "scooter-prohibited": "icons/svg-library/scooter-prohibited.f23e4.svg",
        "scooter": "icons/svg-library/scooter.6e962.svg",
        "seafood-block": "icons/svg-library/seafood-block.a60b5.svg",
        "seafood-outline": "icons/svg-library/seafood-outline.b2aa4.svg",
        "seafood": "icons/svg-library/seafood.6bbe4.svg",
        "search-block": "icons/svg-library/search-block.61545.svg",
        "search-outline": "icons/svg-library/search-outline.86bd7.svg",
        "search": "icons/svg-library/search.a8775.svg",
        "seat-or-economy-block": "icons/svg-library/seat-or-economy-block.69adb.svg",
        "seat-or-economy-outline": "icons/svg-library/seat-or-economy-outline.fae33.svg",
        "seat-or-economy": "icons/svg-library/seat-or-economy.8f54d.svg",
        "seatbelts-off-block": "icons/svg-library/seatbelts-off-block.16bbe.svg",
        "seatbelts-off-outline": "icons/svg-library/seatbelts-off-outline.aa6e0.svg",
        "seatbelts-off": "icons/svg-library/seatbelts-off.3178e.svg",
        "seatbelts-on-block": "icons/svg-library/seatbelts-on-block.fe9ee.svg",
        "seatbelts-on-outline": "icons/svg-library/seatbelts-on-outline.7d801.svg",
        "seatbelts-on": "icons/svg-library/seatbelts-on.6b1e9.svg",
        "secure-payment-block": "icons/svg-library/secure-payment-block.4f09a.svg",
        "secure-payment-outline": "icons/svg-library/secure-payment-outline.7e236.svg",
        "secure-payment": "icons/svg-library/secure-payment.61844.svg",
        "security-block": "icons/svg-library/security-block.d602e.svg",
        "security-outline": "icons/svg-library/security-outline.cf78c.svg",
        "security": "icons/svg-library/security.9c782.svg",
        "service-desk-block": "icons/svg-library/service-desk-block.286ea.svg",
        "service-desk-outline": "icons/svg-library/service-desk-outline.040a1.svg",
        "service-desk": "icons/svg-library/service-desk.6ce89.svg",
        "settings-block": "icons/svg-library/settings-block.8c7d0.svg",
        "settings-outline": "icons/svg-library/settings-outline.f77bb.svg",
        "settings": "icons/svg-library/settings.38e47.svg",
        "seven-block": "icons/svg-library/seven-block.303a0.svg",
        "seven-outline": "icons/svg-library/seven-outline.2c199.svg",
        "seven": "icons/svg-library/seven.d19c2.svg",
        "share-android-block": "icons/svg-library/share-android-block.bbe04.svg",
        "share-android-outline": "icons/svg-library/share-android-outline.8706f.svg",
        "share-android": "icons/svg-library/share-android.d175c.svg",
        "sharp-objects-prohibited": "icons/svg-library/sharp-objects-prohibited.6b016.svg",
        "sharp-objects": "icons/svg-library/sharp-objects.7761e.svg",
        "shopping-cart-active": "icons/svg-library/shopping-cart-active.3e94e.svg",
        "shopping-cart-block": "icons/svg-library/shopping-cart-block.792af.svg",
        "shopping-cart-outline": "icons/svg-library/shopping-cart-outline.e94d7.svg",
        "shopping-cart": "icons/svg-library/shopping-cart.ae8cc.svg",
        "shower-block": "icons/svg-library/shower-block.0bb37.svg",
        "shower-outline": "icons/svg-library/shower-outline.93e23.svg",
        "shower": "icons/svg-library/shower.73201.svg",
        "single-pax-block": "icons/svg-library/single-pax-block.86a11.svg",
        "single-pax-outline": "icons/svg-library/single-pax-outline.8cabb.svg",
        "single-pax": "icons/svg-library/single-pax.16c9f.svg",
        "six-block": "icons/svg-library/six-block.c2083.svg",
        "six-outline": "icons/svg-library/six-outline.ea398.svg",
        "six": "icons/svg-library/six.411dd.svg",
        "skip-15s-back-block": "icons/svg-library/skip-15s-back-block.7326f.svg",
        "skip-15s-back-outline": "icons/svg-library/skip-15s-back-outline.6cf55.svg",
        "skip-15s-back": "icons/svg-library/skip-15s-back.b02ca.svg",
        "skip-15s-forward-block": "icons/svg-library/skip-15s-forward-block.baaba.svg",
        "skip-15s-forward-outline": "icons/svg-library/skip-15s-forward-outline.57859.svg",
        "skip-15s-forward": "icons/svg-library/skip-15s-forward.c7e35.svg",
        "skis-block": "icons/svg-library/skis-block.d4bba.svg",
        "skis-outline": "icons/svg-library/skis-outline.04c20.svg",
        "skis": "icons/svg-library/skis.ed350.svg",
        "smoking-block": "icons/svg-library/smoking-block.29f07.svg",
        "smoking-outline": "icons/svg-library/smoking-outline.871cf.svg",
        "smoking-prohibited": "icons/svg-library/smoking-prohibited.eef3c.svg",
        "smoking": "icons/svg-library/smoking.4ec9c.svg",
        "snacks-block": "icons/svg-library/snacks-block.b5a58.svg",
        "snacks-outline": "icons/svg-library/snacks-outline.ab277.svg",
        "snacks": "icons/svg-library/snacks.ed8de.svg",
        "sort-ascending-block": "icons/svg-library/sort-ascending-block.ebfa7.svg",
        "sort-ascending-outline": "icons/svg-library/sort-ascending-outline.248f7.svg",
        "sort-ascending": "icons/svg-library/sort-ascending.6589c.svg",
        "sort-block": "icons/svg-library/sort-block.bc931.svg",
        "sort-descending-block": "icons/svg-library/sort-descending-block.6dd4a.svg",
        "sort-descending-outline": "icons/svg-library/sort-descending-outline.73837.svg",
        "sort-descending": "icons/svg-library/sort-descending.add9b.svg",
        "sort-outline": "icons/svg-library/sort-outline.0fec4.svg",
        "sort": "icons/svg-library/sort.7e3d0.svg",
        "spare-lithium-batteries": "icons/svg-library/spare-lithium-batteries.36c51.svg",
        "sparkling-wine-block": "icons/svg-library/sparkling-wine-block.576cc.svg",
        "sparkling-wine-glass-block": "icons/svg-library/sparkling-wine-glass-block.33275.svg",
        "sparkling-wine-glass-outline": "icons/svg-library/sparkling-wine-glass-outline.a5e88.svg",
        "sparkling-wine-glass": "icons/svg-library/sparkling-wine-glass.e6452.svg",
        "sparkling-wine-outline": "icons/svg-library/sparkling-wine-outline.ae5b8.svg",
        "sparkling-wine": "icons/svg-library/sparkling-wine.02cc8.svg",
        "sports-equipment-block": "icons/svg-library/sports-equipment-block.f7949.svg",
        "sports-equipment-outline": "icons/svg-library/sports-equipment-outline.6fe06.svg",
        "sports-equipment": "icons/svg-library/sports-equipment.4e9f4.svg",
        "star-block": "icons/svg-library/star-block.d5e29.svg",
        "star-outline": "icons/svg-library/star-outline.df967.svg",
        "star": "icons/svg-library/star.f4c22.svg",
        "stopover-block": "icons/svg-library/stopover-block.94f27.svg",
        "stopover-outline": "icons/svg-library/stopover-outline.b9a0b.svg",
        "stopover": "icons/svg-library/stopover.ec881.svg",
        "subtitles-block": "icons/svg-library/subtitles-block.d920c.svg",
        "subtitles-outline": "icons/svg-library/subtitles-outline.52790.svg",
        "subtitles": "icons/svg-library/subtitles.e2538.svg",
        "surfboard-block": "icons/svg-library/surfboard-block.9af15.svg",
        "surfboard-outline": "icons/svg-library/surfboard-outline.5cb48.svg",
        "surfboard": "icons/svg-library/surfboard.5c577.svg",
        "sustainability-block": "icons/svg-library/sustainability-block.d3d1e.svg",
        "sustainability-outline": "icons/svg-library/sustainability-outline.e1c60.svg",
        "sustainability": "icons/svg-library/sustainability.61253.svg",
        "switch-flights-block": "icons/svg-library/switch-flights-block.c23b8.svg",
        "switch-flights-outline": "icons/svg-library/switch-flights-outline.27c46.svg",
        "switch-flights": "icons/svg-library/switch-flights.6a142.svg",
        "tablet-block": "icons/svg-library/tablet-block.524d4.svg",
        "tablet-outline": "icons/svg-library/tablet-outline.f8264.svg",
        "tablet": "icons/svg-library/tablet.d3056.svg",
        "tail-block": "icons/svg-library/tail-block.bf2e0.svg",
        "tail-outline": "icons/svg-library/tail-outline.3e1ab.svg",
        "tail": "icons/svg-library/tail.43aa2.svg",
        "tap-press-block": "icons/svg-library/tap-press-block.548c0.svg",
        "tap-press-outline": "icons/svg-library/tap-press-outline.32d38.svg",
        "tap-press": "icons/svg-library/tap-press.85cb0.svg",
        "taxi-block": "icons/svg-library/taxi-block.6df52.svg",
        "taxi-outline": "icons/svg-library/taxi-outline.150f4.svg",
        "taxi": "icons/svg-library/taxi.42f82.svg",
        "tazer-prohibited": "icons/svg-library/tazer-prohibited.41608.svg",
        "tazer": "icons/svg-library/tazer.6dd2d.svg",
        "tea-block": "icons/svg-library/tea-block.ff327.svg",
        "tea-outline": "icons/svg-library/tea-outline.e3d87.svg",
        "tea": "icons/svg-library/tea.abf73.svg",
        "three-block": "icons/svg-library/three-block.e2544.svg",
        "three-outline": "icons/svg-library/three-outline.8b12f.svg",
        "three": "icons/svg-library/three.10926.svg",
        "ticket-refund-block": "icons/svg-library/ticket-refund-block.f63a4.svg",
        "ticket-refund-outline": "icons/svg-library/ticket-refund-outline.934e1.svg",
        "ticket-refund": "icons/svg-library/ticket-refund.59c81.svg",
        "tier-points-block": "icons/svg-library/tier-points-block.133b2.svg",
        "tier-points-outline": "icons/svg-library/tier-points-outline.61e5b.svg",
        "tier-points": "icons/svg-library/tier-points.386f6.svg",
        "tier-progress-block": "icons/svg-library/tier-progress-block.a7a87.svg",
        "tier-progress-outline": "icons/svg-library/tier-progress-outline.590b8.svg",
        "tier-progress": "icons/svg-library/tier-progress.b42a9.svg",
        "tiktok-block": "icons/svg-library/tiktok-block.0986d.svg",
        "tiktok-outline": "icons/svg-library/tiktok-outline.7d069.svg",
        "tiktok": "icons/svg-library/tiktok.8bdf6.svg",
        "time-zone-block": "icons/svg-library/time-zone-block.6c067.svg",
        "time-zone-outline": "icons/svg-library/time-zone-outline.06849.svg",
        "time-zone": "icons/svg-library/time-zone.ec90c.svg",
        "timetable": "icons/svg-library/timetable.1978d.svg",
        "tools-and-blunt-instruments-prohibited": "icons/svg-library/tools-and-blunt-instruments-prohibited.ce756.svg",
        "tools-and-blunt-instruments": "icons/svg-library/tools-and-blunt-instruments.770c2.svg",
        "track-playing-block": "icons/svg-library/track-playing-block.58dfc.svg",
        "track-playing-outline": "icons/svg-library/track-playing-outline.b6f1f.svg",
        "track-playing": "icons/svg-library/track-playing.4036d.svg",
        "train-block": "icons/svg-library/train-block.482a5.svg",
        "train-outline": "icons/svg-library/train-outline.4ab0b.svg",
        "train": "icons/svg-library/train.cdb44.svg",
        "transfer-loader-block": "icons/svg-library/transfer-loader-block.ce557.svg",
        "transfer-loader-outline": "icons/svg-library/transfer-loader-outline.57c9a.svg",
        "transfer-loader": "icons/svg-library/transfer-loader.59b95.svg",
        "trash-block": "icons/svg-library/trash-block.110c2.svg",
        "trash-outline": "icons/svg-library/trash-outline.9cc52.svg",
        "trash": "icons/svg-library/trash.62e69.svg",
        "travel-documents-block": "icons/svg-library/travel-documents-block.f7abf.svg",
        "travel-documents-outline": "icons/svg-library/travel-documents-outline.3fc38.svg",
        "travel-documents": "icons/svg-library/travel-documents.071d1.svg",
        "travel-insurance-block": "icons/svg-library/travel-insurance-block.a8f17.svg",
        "travel-insurance-outline": "icons/svg-library/travel-insurance-outline.e98f0.svg",
        "travel-insurance": "icons/svg-library/travel-insurance.8121e.svg",
        "treats-block": "icons/svg-library/treats-block.b1f19.svg",
        "treats-outline": "icons/svg-library/treats-outline.ede72.svg",
        "treats": "icons/svg-library/treats.866fd.svg",
        "trending-arrow-up": "icons/svg-library/trending-arrow-up.4521d.svg",
        "twenty-four-hour-refund-block": "icons/svg-library/twenty-four-hour-refund-block.d3c63.svg",
        "twenty-four-hour-refund-outline": "icons/svg-library/twenty-four-hour-refund-outline.5246b.svg",
        "twenty-four-hour-refund": "icons/svg-library/twenty-four-hour-refund.62c2e.svg",
        "twitter": "icons/svg-library/twitter.13171.svg",
        "two-block": "icons/svg-library/two-block.adc67.svg",
        "two-outline": "icons/svg-library/two-outline.1aab9.svg",
        "two": "icons/svg-library/two.519cf.svg",
        "update-block": "icons/svg-library/update-block.7e224.svg",
        "update-cart-block": "icons/svg-library/update-cart-block.385ea.svg",
        "update-cart-outline": "icons/svg-library/update-cart-outline.1c14b.svg",
        "update-cart": "icons/svg-library/update-cart.eeb72.svg",
        "update-outline": "icons/svg-library/update-outline.e9229.svg",
        "update": "icons/svg-library/update.59408.svg",
        "upgrade-block": "icons/svg-library/upgrade-block.d7d46.svg",
        "upgrade-outline": "icons/svg-library/upgrade-outline.996ae.svg",
        "upgrade": "icons/svg-library/upgrade.b24ac.svg",
        "upload-block": "icons/svg-library/upload-block.975ff.svg",
        "upload-outline": "icons/svg-library/upload-outline.8d6b3.svg",
        "upload": "icons/svg-library/upload.6c435.svg",
        "vat-receipt-download-block": "icons/svg-library/vat-receipt-download-block.3be38.svg",
        "vat-receipt-download-outline": "icons/svg-library/vat-receipt-download-outline.12813.svg",
        "vat-receipt-download": "icons/svg-library/vat-receipt-download.745c6.svg",
        "video-series-block": "icons/svg-library/video-series-block.c9232.svg",
        "video-series-outline": "icons/svg-library/video-series-outline.62ff6.svg",
        "video-series": "icons/svg-library/video-series.651d7.svg",
        "visible-block": "icons/svg-library/visible-block.d7914.svg",
        "visible-outline": "icons/svg-library/visible-outline.5a34e.svg",
        "visible": "icons/svg-library/visible.818ab.svg",
        "volume-block": "icons/svg-library/volume-block.47658.svg",
        "volume-low-block": "icons/svg-library/volume-low-block.1904b.svg",
        "volume-low-outline": "icons/svg-library/volume-low-outline.49702.svg",
        "volume-low": "icons/svg-library/volume-low.e4fae.svg",
        "volume-medium-block": "icons/svg-library/volume-medium-block.b9b4b.svg",
        "volume-medium-outline": "icons/svg-library/volume-medium-outline.b16cf.svg",
        "volume-medium": "icons/svg-library/volume-medium.f73cf.svg",
        "volume-mute-block": "icons/svg-library/volume-mute-block.f6303.svg",
        "volume-mute-outline": "icons/svg-library/volume-mute-outline.7c624.svg",
        "volume-mute": "icons/svg-library/volume-mute.22677.svg",
        "volume-outline": "icons/svg-library/volume-outline.e7b8a.svg",
        "volume": "icons/svg-library/volume.ed378.svg",
        "voucher-block": "icons/svg-library/voucher-block.58d7c.svg",
        "voucher-outline": "icons/svg-library/voucher-outline.6d79c.svg",
        "voucher": "icons/svg-library/voucher.d3fdd.svg",
        "wallet-closed-block": "icons/svg-library/wallet-closed-block.ecb56.svg",
        "wallet-closed-outline": "icons/svg-library/wallet-closed-outline.7d1e1.svg",
        "wallet-closed": "icons/svg-library/wallet-closed.43526.svg",
        "wallet-open-block": "icons/svg-library/wallet-open-block.1b7ad.svg",
        "wallet-open-outline": "icons/svg-library/wallet-open-outline.630fd.svg",
        "wallet-open": "icons/svg-library/wallet-open.24f7c.svg",
        "water-block": "icons/svg-library/water-block.a973b.svg",
        "water-outline": "icons/svg-library/water-outline.5da88.svg",
        "water": "icons/svg-library/water.01de8.svg",
        "wechat": "icons/svg-library/wechat.c2a97.svg",
        "weibo": "icons/svg-library/weibo.d89a9.svg",
        "wellbeing-block": "icons/svg-library/wellbeing-block.3aec2.svg",
        "wellbeing-outline": "icons/svg-library/wellbeing-outline.07a9c.svg",
        "wellbeing": "icons/svg-library/wellbeing.80c50.svg",
        "whatsapp-block": "icons/svg-library/whatsapp-block.88fe8.svg",
        "whatsapp-outline": "icons/svg-library/whatsapp-outline.b4923.svg",
        "whatsapp": "icons/svg-library/whatsapp.56a46.svg",
        "wifi-aircraft": "icons/svg-library/wifi-aircraft.62b42.svg",
        "wifi-block": "icons/svg-library/wifi-block.c74bb.svg",
        "wifi-low-block": "icons/svg-library/wifi-low-block.c5304.svg",
        "wifi-low-outline": "icons/svg-library/wifi-low-outline.f2f73.svg",
        "wifi-low": "icons/svg-library/wifi-low.eb494.svg",
        "wifi-medium-block": "icons/svg-library/wifi-medium-block.85fa6.svg",
        "wifi-medium-outline": "icons/svg-library/wifi-medium-outline.afad4.svg",
        "wifi-medium": "icons/svg-library/wifi-medium.cf041.svg",
        "wifi-offline-block": "icons/svg-library/wifi-offline-block.4aaae.svg",
        "wifi-offline-outline": "icons/svg-library/wifi-offline-outline.29d45.svg",
        "wifi-offline": "icons/svg-library/wifi-offline.ad9c9.svg",
        "wifi-outline": "icons/svg-library/wifi-outline.d6e55.svg",
        "wifi": "icons/svg-library/wifi.11b96.svg",
        "wine-block": "icons/svg-library/wine-block.8d8f9.svg",
        "wine-glass-block": "icons/svg-library/wine-glass-block.87b1f.svg",
        "wine-glass-outline": "icons/svg-library/wine-glass-outline.d4bc0.svg",
        "wine-glass": "icons/svg-library/wine-glass.08b8d.svg",
        "wine-outline": "icons/svg-library/wine-outline.ffb0e.svg",
        "wine": "icons/svg-library/wine.c196e.svg",
        "world-map-block": "icons/svg-library/world-map-block.81d19.svg",
        "world-map-outline": "icons/svg-library/world-map-outline.5242c.svg",
        "world-map": "icons/svg-library/world-map.26b40.svg",
        "x-block": "icons/svg-library/x-block.9030e.svg",
        "x-outline": "icons/svg-library/x-outline.133c4.svg",
        "x": "icons/svg-library/x.81102.svg",
        "youku": "icons/svg-library/youku.b307a.svg",
        "youtube": "icons/svg-library/youtube.765e8.svg",
        "zero-block": "icons/svg-library/zero-block.a97a6.svg",
        "zero-outline": "icons/svg-library/zero-outline.da712.svg",
        "zero": "icons/svg-library/zero.d00d2.svg"
    },
    "tails": {
        "tail_3k": "icons/tails/tail_3k.26319.svg",
        "tail_6i": "icons/tails/tail_6i.a38f3.svg",
        "tail_9w": "icons/tails/tail_9w.83cfd.svg",
        "tail_a3": "icons/tails/tail_a3.87346.svg",
        "tail_aa": "icons/tails/tail_aa.72aaf.svg",
        "tail_ab": "icons/tails/tail_ab.d66f3.svg",
        "tail_af": "icons/tails/tail_af.de33f.svg",
        "tail_ai": "icons/tails/tail_ai.8ea5b.svg",
        "tail_as": "icons/tails/tail_as.c86bf.svg",
        "tail_at": "icons/tails/tail_at.50166.svg",
        "tail_ay": "icons/tails/tail_ay.d578a.svg",
        "tail_az": "icons/tails/tail_az.189d9.svg",
        "tail_b6": "icons/tails/tail_b6.fb000.svg",
        "tail_ba": "icons/tails/tail_ba.65f11.svg",
        "tail_br": "icons/tails/tail_br.603e3.svg",
        "tail_bt": "icons/tails/tail_bt.e2642.svg",
        "tail_bus": "icons/tails/tail_bus.baf12.svg",
        "tail_ca": "icons/tails/tail_ca.471d6.svg",
        "tail_ci": "icons/tails/tail_ci.776b6.svg",
        "tail_cx": "icons/tails/tail_cx.b2958.svg",
        "tail_cz": "icons/tails/tail_cz.fbeac.svg",
        "tail_dx": "icons/tails/tail_dx.476a7.svg",
        "tail_ei": "icons/tails/tail_ei.0db73.svg",
        "tail_ek": "icons/tails/tail_ek.969ad.svg",
        "tail_et": "icons/tails/tail_et.7e5a3.svg",
        "tail_fi": "icons/tails/tail_fi.94e4d.svg",
        "tail_fj": "icons/tails/tail_fj.8e83e.svg",
        "tail_ga": "icons/tails/tail_ga.8129d.svg",
        "tail_gl": "icons/tails/tail_gl.9f517.svg",
        "tail_ho": "icons/tails/tail_ho.525c1.svg",
        "tail_hu": "icons/tails/tail_hu.6caee.svg",
        "tail_ib": "icons/tails/tail_ib.9fab2.svg",
        "tail_ig": "icons/tails/tail_ig.502ba.svg",
        "tail_ij": "icons/tails/tail_ij.69374.svg",
        "tail_jl": "icons/tails/tail_jl.26b8e.svg",
        "tail_jp": "icons/tails/tail_jp.cb3e6.svg",
        "tail_ju": "icons/tails/tail_ju.62a82.svg",
        "tail_ka": "icons/tails/tail_ka.8c2d8.svg",
        "tail_ke": "icons/tails/tail_ke.a30e0.svg",
        "tail_kl": "icons/tails/tail_kl.79c77.svg",
        "tail_km": "icons/tails/tail_km.084dd.svg",
        "tail_la": "icons/tails/tail_la.0bfbe.svg",
        "tail_lg": "icons/tails/tail_lg.26bd8.svg",
        "tail_lh": "icons/tails/tail_lh.82145.svg",
        "tail_lm": "icons/tails/tail_lm.3ac88.svg",
        "tail_lo": "icons/tails/tail_lo.66008.svg",
        "tail_lx": "icons/tails/tail_lx.cb505.svg",
        "tail_mh": "icons/tails/tail_mh.a4f23.svg",
        "tail_mi": "icons/tails/tail_mi.92842.svg",
        "tail_mu": "icons/tails/tail_mu.05f58.svg",
        "tail_nt": "icons/tails/tail_nt.b3dc0.svg",
        "tail_nz": "icons/tails/tail_nz.eb3ee.svg",
        "tail_ok": "icons/tails/tail_ok.d5e91.svg",
        "tail_oo": "icons/tails/tail_oo.ae561.svg",
        "tail_os": "icons/tails/tail_os.621e9.svg",
        "tail_ou": "icons/tails/tail_ou.a112b.svg",
        "tail_oz": "icons/tails/tail_oz.a000c.svg",
        "tail_pg": "icons/tails/tail_pg.42baa.svg",
        "tail_pr": "icons/tails/tail_pr.dcc61.svg",
        "tail_ps": "icons/tails/tail_ps.bc29d.svg",
        "tail_qf": "icons/tails/tail_qf.862ee.svg",
        "tail_qr": "icons/tails/tail_qr.83ca7.svg",
        "tail_rj": "icons/tails/tail_rj.6478e.svg",
        "tail_s7": "icons/tails/tail_s7.2e522.svg",
        "tail_sb": "icons/tails/tail_sb.1087a.svg",
        "tail_sk": "icons/tails/tail_sk.fa690.svg",
        "tail_sn": "icons/tails/tail_sn.cd73d.svg",
        "tail_sq": "icons/tails/tail_sq.c3556.svg",
        "tail_su": "icons/tails/tail_su.93e9f.svg",
        "tail_sv": "icons/tails/tail_sv.1b1b1.svg",
        "tail_tf": "icons/tails/tail_tf.ec804.svg",
        "tail_tg": "icons/tails/tail_tg.c436e.svg",
        "tail_tk": "icons/tails/tail_tk.2d9d4.svg",
        "tail_tn": "icons/tails/tail_tn.1e01a.svg",
        "tail_tp": "icons/tails/tail_tp.15f85.svg",
        "tail_trn": "icons/tails/tail_trn.642da.svg",
        "tail_uk": "icons/tails/tail_uk.f6d24.svg",
        "tail_ul": "icons/tails/tail_ul.1b978.svg",
        "tail_vn": "icons/tails/tail_vn.b582b.svg",
        "tail_wf": "icons/tails/tail_wf.de616.svg",
        "tail_wy": "icons/tails/tail_wy.ca41e.svg"
    }
};
export var styles = {
    "index": "styles/index.55ceb.css"
};
export var fonts = {
    "FinnairHeadline": {
        "otf": [
            "fonts/FinnairHeadline/FinnairHeadline-Black.otf",
            "fonts/FinnairHeadline/FinnairHeadline-Bold.otf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBlack.otf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBold.otf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedLight.otf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedMedium.otf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedRegular.otf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBlack.otf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBold.otf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedLight.otf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedMedium.otf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedRegular.otf",
            "fonts/FinnairHeadline/FinnairHeadline-Light.otf",
            "fonts/FinnairHeadline/FinnairHeadline-Medium.otf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBlack.otf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBold.otf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowLight.otf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowMedium.otf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowRegular.otf",
            "fonts/FinnairHeadline/FinnairHeadline-Regular.otf",
            "fonts/FinnairHeadline/FinnairHeadline-WideBlack.otf",
            "fonts/FinnairHeadline/FinnairHeadline-WideBold.otf",
            "fonts/FinnairHeadline/FinnairHeadline-WideLight.otf",
            "fonts/FinnairHeadline/FinnairHeadline-WideMedium.otf",
            "fonts/FinnairHeadline/FinnairHeadline-WideRegular.otf"
        ],
        "ttf": [
            "fonts/FinnairHeadline/FinnairHeadline-Black.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-Bold.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBlack.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBold.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedLight.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedMedium.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedRegular.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBlack.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBold.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedLight.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedMedium.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedRegular.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-Light.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-Medium.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBlack.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBold.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowLight.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowMedium.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowRegular.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-Regular.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-WideBlack.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-WideBold.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-WideLight.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-WideMedium.ttf",
            "fonts/FinnairHeadline/FinnairHeadline-WideRegular.ttf"
        ],
        "woff": [
            "fonts/FinnairHeadline/FinnairHeadline-Black.woff",
            "fonts/FinnairHeadline/FinnairHeadline-Bold.woff",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBlack.woff",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBold.woff",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedLight.woff",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedMedium.woff",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedRegular.woff",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBlack.woff",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBold.woff",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedLight.woff",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedMedium.woff",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedRegular.woff",
            "fonts/FinnairHeadline/FinnairHeadline-Light.woff",
            "fonts/FinnairHeadline/FinnairHeadline-Medium.woff",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBlack.woff",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBold.woff",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowLight.woff",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowMedium.woff",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowRegular.woff",
            "fonts/FinnairHeadline/FinnairHeadline-Regular.woff",
            "fonts/FinnairHeadline/FinnairHeadline-WideBlack.woff",
            "fonts/FinnairHeadline/FinnairHeadline-WideBold.woff",
            "fonts/FinnairHeadline/FinnairHeadline-WideLight.woff",
            "fonts/FinnairHeadline/FinnairHeadline-WideMedium.woff",
            "fonts/FinnairHeadline/FinnairHeadline-WideRegular.woff"
        ],
        "woff2": [
            "fonts/FinnairHeadline/FinnairHeadline-Black.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-Bold.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBlack.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedBold.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedLight.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedMedium.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-CondensedRegular.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBlack.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedBold.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedLight.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedMedium.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-ExpandedRegular.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-Light.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-Medium.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBlack.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowBold.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowLight.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowMedium.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-NarrowRegular.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-Regular.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-WideBlack.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-WideBold.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-WideLight.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-WideMedium.woff2",
            "fonts/FinnairHeadline/FinnairHeadline-WideRegular.woff2"
        ]
    },
    "FinnairSans": {
        "ttf": [
            "fonts/FinnairSans/FinnairSans-Black.ttf",
            "fonts/FinnairSans/FinnairSans-BlackItalic.ttf",
            "fonts/FinnairSans/FinnairSans-Bold.ttf",
            "fonts/FinnairSans/FinnairSans-BoldItalic.ttf",
            "fonts/FinnairSans/FinnairSans-Italic.ttf",
            "fonts/FinnairSans/FinnairSans-Light.ttf",
            "fonts/FinnairSans/FinnairSans-LightItalic.ttf",
            "fonts/FinnairSans/FinnairSans-Medium.ttf",
            "fonts/FinnairSans/FinnairSans-MediumItalic.ttf",
            "fonts/FinnairSans/FinnairSans-Regular.ttf"
        ],
        "woff": [
            "fonts/FinnairSans/FinnairSans-Black.woff",
            "fonts/FinnairSans/FinnairSans-BlackItalic.woff",
            "fonts/FinnairSans/FinnairSans-Bold.woff",
            "fonts/FinnairSans/FinnairSans-BoldItalic.woff",
            "fonts/FinnairSans/FinnairSans-Italic.woff",
            "fonts/FinnairSans/FinnairSans-Light.woff",
            "fonts/FinnairSans/FinnairSans-LightItalic.woff",
            "fonts/FinnairSans/FinnairSans-Medium.woff",
            "fonts/FinnairSans/FinnairSans-MediumItalic.woff",
            "fonts/FinnairSans/FinnairSans-Regular.woff"
        ],
        "woff2": [
            "fonts/FinnairSans/FinnairSans-Black.woff2",
            "fonts/FinnairSans/FinnairSans-BlackItalic.woff2",
            "fonts/FinnairSans/FinnairSans-Bold.woff2",
            "fonts/FinnairSans/FinnairSans-BoldItalic.woff2",
            "fonts/FinnairSans/FinnairSans-Italic.woff2",
            "fonts/FinnairSans/FinnairSans-Light.woff2",
            "fonts/FinnairSans/FinnairSans-LightItalic.woff2",
            "fonts/FinnairSans/FinnairSans-Medium.woff2",
            "fonts/FinnairSans/FinnairSans-MediumItalic.woff2",
            "fonts/FinnairSans/FinnairSans-Regular.woff2"
        ]
    },
    "FinnairText": {
        "otf": [
            "fonts/FinnairText/FinnairText-Bold.otf",
            "fonts/FinnairText/FinnairText-BoldItalic.otf",
            "fonts/FinnairText/FinnairText-Medium.otf",
            "fonts/FinnairText/FinnairText-MediumItalic.otf",
            "fonts/FinnairText/FinnairText-Regular.otf",
            "fonts/FinnairText/FinnairText-RegularItalic.otf"
        ],
        "ttf": [
            "fonts/FinnairText/FinnairText-Bold.ttf",
            "fonts/FinnairText/FinnairText-BoldItalic.ttf",
            "fonts/FinnairText/FinnairText-Medium.ttf",
            "fonts/FinnairText/FinnairText-MediumItalic.ttf",
            "fonts/FinnairText/FinnairText-Regular.ttf",
            "fonts/FinnairText/FinnairText-RegularItalic.ttf"
        ],
        "woff": [
            "fonts/FinnairText/FinnairText-Bold.woff",
            "fonts/FinnairText/FinnairText-BoldItalic.woff",
            "fonts/FinnairText/FinnairText-Medium.woff",
            "fonts/FinnairText/FinnairText-MediumItalic.woff",
            "fonts/FinnairText/FinnairText-Regular.woff",
            "fonts/FinnairText/FinnairText-RegularItalic.woff"
        ],
        "woff2": [
            "fonts/FinnairText/FinnairText-Bold.woff2",
            "fonts/FinnairText/FinnairText-BoldItalic.woff2",
            "fonts/FinnairText/FinnairText-Medium.woff2",
            "fonts/FinnairText/FinnairText-MediumItalic.woff2",
            "fonts/FinnairText/FinnairText-Regular.woff2",
            "fonts/FinnairText/FinnairText-RegularItalic.woff2"
        ]
    }
};
